import chair from "../../../../assets/pics/Chair.svg";
import standing from "../../../../assets2/icons/Standing.png";
export default function VenueIcons({
	data,
	sittingCapacity,
	standingCapacity,
}) {
	return (
		<div className="flex items-center w-full gap-4 min-h-[20px]">
			<div className="flex items-center gap-1">
				<img src={chair} alt="" />
				<p className="text-secondary font-outfit font-normal text-[15px] leading-[156%] tracking-[0.01em]">
					{sittingCapacity}
				</p>
			</div>
			<div className="flex items-center gap-1">
				<img src={standing} alt="" className="w-4 h-4" />
				<p className="text-secondary font-outfit font-normal text-[15px] leading-[156%] tracking-[0.01em]">
					{standingCapacity}
				</p>
			</div>
		</div>
	);
}
